export default class CompanyTransportDetailsResponse {
    constructor(supportedLocales) {
        this.id = null;
        this.transport = {};
       this.transportToMoneyRatio = [];
       this.pointsPerKilometer = null;
       this.pointsPerActivity = null;
       this.teamMemberPointsPerActivity = null;
    }

    static assign(from, to, locale) {
        if (from) {
            to.id = from.id;
            to.transport = from.transport;   
            to.transportToMoneyRatio = from.transportToMoneyRatio;
            to.pointsPerKilometer = from.pointsPerKilometer;
            to.pointsPerActivity = from.pointsPerActivity;
            to.teamMemberPointsPerActivity = from.teamMemberPointsPerActivity;         
            if(to.transportToMoneyRatio){
                to.transportToMoneyRatio.forEach((c)=>{                   
                    if (c.dateFrom) {
                        c.dateFrom = new Date(c.dateFrom);
                    }
                })
            }
        } else {
            to = new CompanyTransportDetailsResponse();
        }
    }

    static copy(to, from, locale) {
        CompanyTransportDetailsResponse.assign(from, to, locale);
        return to;
    }
}
